import $ from 'jquery'

const sectionTogglePointerScroll = new WeakMap()
const SECTION_TOGGLE_ORIGINAL_ID = 'sectionToggleOriginalId'

function parseSectionToggleTriggerFromTarget(target) {
  if (!(target instanceof Element)) {
    return null
  }
  const a = target.closest('a.js-section-toggle-trigger')
  if (!a) {
    return null
  }
  const href = a.getAttribute('href')
  if (!href || href.charAt(0) !== '#') {
    return null
  }
  const id = href.slice(1)
  if (!/^section-toggle-[a-z0-9]+$/.test(id)) {
    return null
  }
  return { a, id }
}

function getSectionToggleAnchorPlaceholder(el, id) {
  return el.parentElement
    ? el.parentElement.querySelector(`.js-section-toggle-anchor-placeholder[data-section-toggle-id="${id}"]`)
    : null
}

function moveSectionIdToAnchorPlaceholder(el, id) {
  if (el.id !== id) {
    return
  }
  let anchor = getSectionToggleAnchorPlaceholder(el, id)
  if (!anchor) {
    anchor = document.createElement('span')
    anchor.className = 'js-section-toggle-anchor-placeholder'
    anchor.setAttribute('data-section-toggle-id', id)
    anchor.setAttribute('aria-hidden', 'true')
    anchor.style.cssText = 'display:block;height:0;overflow:hidden;'
    el.parentElement.insertBefore(anchor, el)
  }
  anchor.id = id
  el.dataset[SECTION_TOGGLE_ORIGINAL_ID] = id
  el.removeAttribute('id')
}

function restoreSectionIdFromAnchorPlaceholder(el) {
  const originalId = el.dataset[SECTION_TOGGLE_ORIGINAL_ID]
  if (!originalId) {
    return
  }
  const anchor = getSectionToggleAnchorPlaceholder(el, originalId)
  if (anchor) {
    anchor.removeAttribute('id')
    anchor.parentElement.removeChild(anchor)
  }
  el.id = originalId
  delete el.dataset[SECTION_TOGGLE_ORIGINAL_ID]
}

function restoreViewportAfterReflow(scrollX, scrollY) {
  const apply = () => {
    window.scrollTo(scrollX, scrollY)
  }
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      apply()
      window.setTimeout(apply, 0)
    })
  })
}

function lockViewport(scrollX, scrollY, durationMs) {
  const end = Date.now() + durationMs
  const tick = () => {
    window.scrollTo(scrollX, scrollY)
    if (Date.now() < end) {
      requestAnimationFrame(tick)
    }
  }
  tick()
}

function closeSiblingSectionToggles(targetEl) {
  const parent = targetEl.parentElement
  if (!parent) return

  const siblings = parent.children
  for (const sibling of siblings) {
    if (
      sibling !== targetEl &&
      !sibling.classList.contains('is-section-toggle-collapsed') &&
      (sibling.classList.contains('vc_section') || sibling.classList.contains('vc_row'))
    ) {
      const siblingId = sibling.dataset[SECTION_TOGGLE_ORIGINAL_ID] || sibling.id
      if (siblingId && /^section-toggle-[a-z0-9]+$/.test(siblingId)) {
        moveSectionIdToAnchorPlaceholder(sibling, siblingId)
        sibling.classList.add('is-section-toggle-collapsed')
        const triggers = document.querySelectorAll(`a[href="#${siblingId}"].js-section-toggle-trigger`)
        triggers.forEach(trigger => trigger.setAttribute('aria-expanded', 'false'))
      }
    }
  }
}

$(document).ready(dhsv_vc_button)

function dhsv_vc_button() {
  document.addEventListener(
    'pointerdown',
    e => {
      if (e.pointerType === 'mouse' && e.button !== 0) {
        return
      }
      const ctx = parseSectionToggleTriggerFromTarget(e.target)
      if (!ctx) {
        return
      }
      sectionTogglePointerScroll.set(ctx.a, {
        x: window.scrollX,
        y: window.scrollY,
        t: Date.now(),
      })
    },
    true
  )

  document.addEventListener(
    'click',
    e => {
      const ctx = parseSectionToggleTriggerFromTarget(e.target)
      if (!ctx) {
        return
      }
      const { a, id } = ctx
      e.preventDefault()

      let el = document.getElementById(id)

      // If we got the placeholder span, find the actual section element
      if (el && el.classList.contains('js-section-toggle-anchor-placeholder')) {
        const parent = el.parentElement
        if (parent) {
          el = parent.querySelector(`[data-section-toggle-original-id="${id}"]`)
        }
      }

      if (!el) {
        return
      }

      const wasCollapsed = el.classList.contains('is-section-toggle-collapsed')
      if (wasCollapsed) {
        closeSiblingSectionToggles(el)
        if (el.dataset[SECTION_TOGGLE_ORIGINAL_ID]) {
          restoreSectionIdFromAnchorPlaceholder(el)
        }
        el.classList.remove('is-section-toggle-collapsed')
      } else {
        let scrollX = window.scrollX
        let scrollY = window.scrollY
        const stored = sectionTogglePointerScroll.get(a)
        if (stored && Date.now() - stored.t < 800) {
          scrollX = stored.x
          scrollY = stored.y
        }
        moveSectionIdToAnchorPlaceholder(el, id)
        el.classList.add('is-section-toggle-collapsed')
        restoreViewportAfterReflow(scrollX, scrollY)
        lockViewport(scrollX, scrollY, 400)
      }
      const expanded = !el.classList.contains('is-section-toggle-collapsed')
      a.setAttribute('aria-expanded', expanded ? 'true' : 'false')

      if (wasCollapsed) {
        void el.offsetHeight
        window.setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }, 120)
      }
    },
    true
  )
}
